import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { StatusLabel } from '../../Components/StatusLabel'
import { LinkEdit } from '../../Components/Link/Edit'
import { LinkView } from '../../Components/Link/View/index'
import { ButtonDeleteInline } from '../../Components/Buttons/ButtonDeleteInline/index'
import { userStatusSort } from '../../Utils/Table'
import SimpleTableTable from '../../Components/SimpleTableTable'
import { CONFIG } from '../../Config/config'

const roleLabel = {
  [CONFIG.USER_ROLE.ADMIN]: 'Administrator',
  [CONFIG.USER_ROLE.CITY_MANAGER]: 'City Manager',
  [CONFIG.USER_ROLE.CLIENT_ADMIN]: 'Client Admin',
  [CONFIG.USER_ROLE.CLIENT]: 'Client',
  [CONFIG.USER_ROLE.RECRUITER]: 'Recruiter',
  [CONFIG.USER_ROLE.SPY]: 'Spy',
}

const getUsersTableData = ({ usersList }) =>
  usersList.map(({ id, firstName, lastName, role, client, status, email }) => ({
    id,
    'NAME': `${firstName} ${lastName}`,
    'ROLE': roleLabel[role] || role,
    'CLIENT': client && client.name ? client.name : '-',
    'EMAIL ADDRESS': email,
    'STATUS': status,
  }))

const ActivityTable = ({
  usersList,
  handleUserDelete,
  history,
  match,
  ...props
}) => {
  const header = [
    'NAME',
    'ROLE',
    'CLIENT',
    'EMAIL ADDRESS',
    'STATUS',
    'ACTIONS',
  ]

  const sortOn = [
    'NAME',
    'ROLE',
    'CLIENT',
    'EMAIL ADDRESS',
    { label: 'STATUS', sort: userStatusSort },
  ]

  const filterOn = [
    'ROLE', 
    'CLIENT', 
    { label: 'STATUS', sort: userStatusSort },
  ]

  const action = userData => history.push(`${match.url}/${userData.id}`)

  const data = getUsersTableData({ usersList })

  const postRowRender = userData => {
    const viewURL = `${match.url}/${userData.id}`
    const editURL = `${match.url}/${userData.id}/edit`
    return {
      ...userData,
      'STATUS': (
        <StatusLabel status={userData.STATUS}>{userData.STATUS}</StatusLabel>
      ),
      'ACTIONS': (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <LinkView to={viewURL} />
          <LinkEdit to={editURL} />
          <ButtonDeleteInline
            onClickHandler={() => handleUserDelete(userData.id)}
          />
        </div>
      ),
    }
  }

  const searchOn = [
    'NAME',
    'ROLE',
    'CLIENT',
    'EMAIL ADDRESS',
  ]

  return (
    <SimpleTableTable
      header={header}
      data={data}
      sortOn={sortOn}
      filterOn={filterOn}
      postRowRender={postRowRender}
      action={action}
      searchOn={searchOn}
    />
  )
}

ActivityTable.propTypes = {
  usersList: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleUserDelete: PropTypes.func.isRequired,
}

export default withRouter(ActivityTable)



// WEBPACK FOOTER //
// ./src/Containers/UserManagement/UsersListTable.jsx